import {responsiveHeight, responsiveWidth} from 'react-native-responsive-dimensions';
import {Store} from "../reducers/store";
import {Image} from "react-native";
import {
    FONT_FAMILY,
    FONT_FAMILY_BOLDEST, FONT_SIZE, FONT_SIZE_S,
    MARGIN_VALUE,
    MARGIN_VALUE_LANDSCAPE,
    TEXT_PRIMARY_COLOR
} from "../constants/styleConstants";

function storeInitialized() {
    return !!(Store && Store.getState() && Store.getState().data && Store.getState().data.config)
}

export function RW(value) {
    return responsiveWidth(value)
}

export function RH(value) {
    return responsiveHeight(value)
}

// responsiveConstant
export function RC(portrait = true) {
    return {
        margin() {
            return portrait ?
                RW(MARGIN_VALUE) :
                RW(MARGIN_VALUE_LANDSCAPE)
        },
        maxHeight() {
            return portrait ?
                RH(100) - 2 * RW(MARGIN_VALUE) :
                RH(100) - 2 * RW(MARGIN_VALUE_LANDSCAPE)
        },
        maxWidth() {
            return portrait ?
                RW(100) - 2 * RW(MARGIN_VALUE) :
                RW(100) - 2 * RW(MARGIN_VALUE_LANDSCAPE)
        },
        inputPadding() {
            return RW(4)
        },
        titleText() {
            const color = storeInitialized ? Store.getState().data.config.welcome_text_color : TEXT_PRIMARY_COLOR

            return {
                fontFamily: FONT_FAMILY_BOLDEST,
                fontSize: portrait ? FONT_SIZE : FONT_SIZE_S,
                textAlign: 'center',
                color: color,
            }
        },
        subTitleText() {
            const color = storeInitialized ? Store.getState().data.config.welcome_text_color : TEXT_PRIMARY_COLOR

            return {
                fontFamily: FONT_FAMILY,
                color: color,
                fontSize: portrait ? FONT_SIZE : FONT_SIZE_S,
                textAlign: 'center'
            }
        },
        buttonHeight() {
            return RH(8)
        },
        buttonBorderWidth() {
            return RW(portrait ? 0.2 : 0.1)
        },
        buttonBorderRadius() {
            return RW(portrait ? 1 : 0.5)
        },
        inputMarginBottom() {
            return this.buttonHeight() / (portrait ? 2 : 4)
        }
    }
}